import { FC, ReactNode, useCallback, useContext, useReducer } from 'react'
import {
    GenericDialogContext,
    IGenericDialogContextState,
    INITIAL_STATE
} from './context.ts';
import { GenericDialogV2Reducer } from './reducer.ts';


interface IGenericDialogProviderProps {
    children: ReactNode | ReactNode[]
}

export const GenericDialogV2Provider: FC<IGenericDialogProviderProps> = ({ children }) => {
    const [{ ctxDisabled, ctxLoading }, dispatch] = useReducer(GenericDialogV2Reducer, INITIAL_STATE)

    return (
        <GenericDialogContext.Provider
            value={{
                ctxDisabled,
                ctxLoading,
                dispatch,
            }}>
            {children}
        </GenericDialogContext.Provider>
    )
}

export const useGenericDialogV2 = (): Omit<IGenericDialogContextState, 'dispatch'> & {
    setCtxState: <k extends keyof IGenericDialogContextState = keyof IGenericDialogContextState>(key: k, value: IGenericDialogContextState[k]) => void
} => {
    const { dispatch, ctxDisabled, ctxLoading } = useContext(GenericDialogContext)


    const setCtxState = useCallback(<k extends keyof IGenericDialogContextState = keyof IGenericDialogContextState>(key: k, value: IGenericDialogContextState[k]) => {
        if (dispatch) {
            dispatch({ type: 'setCtxState', payload: { key, value } })
        }
    }, [dispatch])

    return {
        ctxDisabled,
        ctxLoading,
        setCtxState
    }
}
